export const enum SYSTEM {
  ANDROID = 'android',
  IOS = 'ios',
  // 判断是否在APP内的关键字 在user-agent里面
  IS_APP_KEY = 'fromapp',
}

export const enum Method {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  DELETE = 'DELETE',
}

export enum LANGUAGE {
  en_US = 'en_US',
  pt_BR = 'pt_BR',
  zh_HK = 'zh_HK',
  zh_MO = 'zh_MO',
  zh_CN = 'zh_CN',
}

/**
 * 车联协议签署按钮状态
 */
export enum SIGN_STATE {
  SIGNED = '1',
  UNSIGNED = '2',
  UPDATE = '3',
}

export enum PROTOCOL_TYPE {
  // 用户协议
  USER = 1,
  // 隐私协议
  PRIVACY = 2,
  // 注销协议
  CANCEL = 3,
  // 试驾协议
  TESTDRIVE = 4,
  // 订购协议
  SUBSCRIPTION = 5,
  // 预售协议
  PRESALE = 7,
  // 活动协议
  EVENT = 9,
  // 互联服务协议
  TELEMATIC = 11,
}

export const TITLE_MAP: {
  [key: number]: string
} = {
  1: 'oc_user_agreement', // 用户协议
  2: 'oc_privacy_policy', // 隐私协议
  3: 'od_user_cancellation_agreement', // 用户注销协议
  11: 'oc_connect_service_agreement', // 车联服务协议
  24: 'oc_license_agreement', // FOTA用户许可协议
  25: 'oc_update_license', // 更新许可和服务协议
}
